// @ts-nocheck
import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

const getAccountPagoMovil = async () => {
  return privateRequest.get(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL}s`);
};

const postAccountPagoMovil = async (data: Record<string, unknown>) => {
  return privateRequest.post(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL}`, data);
};

const updateAccountPagoMovil = async (data: Record<string, unknown>) => {
  return privateRequest.patch(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL}`, data);
};

const deleteAccountPagoMovil = async (id: string | number) => {
  return privateRequest.delete(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL}/${encodeURIComponent(id)}`);
};

export {deleteAccountPagoMovil, getAccountPagoMovil, postAccountPagoMovil, updateAccountPagoMovil};
